import Immutable from 'seamless-immutable';
import { isFormalMeal } from '../../helper/common-helper';
import iParkHelper from '../../helper/iPark/iParkHelper';

const defaultState = Immutable.from({
  shopDetail: {},
  shopIntroImgs: [],
  menuList: [],
  errorMessage: {},
  userInfo: {},
  serviceCardVO: {},
  socketCardData: [],
  activeSocketCard: false,
  toastProps: null,
  shopInfo: null,
  loading: '',
});

export default (state = defaultState, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET_SHOP_DETAIL':
      return state.set('shopDetail', payload || {});
    case 'SET_SHOP_INTRO_IMGS':
      return state.set('shopIntroImgs', payload || []);
    case 'SET_MENU_LIST': {
      let res = payload || [];
      if (iParkHelper.isIParkEvn()) {
        res = res.filter(item => {
          const { uniqueId } = item;
          return uniqueId === 'WM' || uniqueId === 'TS';
        });
      }
      return state.set('menuList', res);
    }

    case 'SET_ERROR_MSG':
      return state.set('errorMessage', payload || {});
    case 'SET_USER_INFO':
      return state.set('userInfo', payload || {});
    case 'SET_SOCKET_CARD_DATA': {
      const { memberVO, tableWay } = state.serviceCardVO;
      let activeSocketCard = false;
      const formatData = (item, index, cardItem) => {
        let newCardItem;
        switch (tableWay) {
          case 'oneTableOneBill': {
            newCardItem = cardItem.set('ownerId', item.owner.ownerId);
            delete payload[index];
            break;
          }
          case 'oneTableMoreBill': {
            if (cardItem.customerId === null) {
              newCardItem = cardItem.set('iconUri', item.owner.userPicPath).set('name', item.owner.userNickname);
              delete payload[index];
              if (item.owner.ownerId === memberVO.customerId) {
                activeSocketCard = true;
              }
            } else {
              newCardItem = cardItem.set('ownerId', item.owner.ownerId);
              delete payload[index];
            }
            break;
          }
          default:
            break;
        }
        return newCardItem;
      };
      return state
        .updateIn(['serviceCardVO', 'cardItems'], cardItems =>
          cardItems.flatMap(cardItem => {
            let newCardItem;
            const activeCardItem = cardItem.orderStatus === 1 || cardItem.orderStatus === 3 || cardItem.orderStatus === 300;
            payload.forEach((item, index) => {
              if (item.orderId && cardItem.tradeId === item.orderId && activeCardItem) {
                newCardItem = formatData(item, index, cardItem);
              }
            });
            return newCardItem || cardItem.set('ownerId', cardItem.customerId || (memberVO && memberVO.customerId));
          }),
        )
        .set(
          'socketCardData',
          payload.filter(item => {
            return item !== undefined;
          }),
        )
        .set(
          'activeSocketCard',
          activeSocketCard ||
            payload.some(item => {
              return item.owner.ownerId === memberVO.customerId;
            }),
        );
    }
    case 'SET_SERVICE_CARDVO':
      if (!payload) {
        return state.set('serviceCardVO', {});
      }
      return state
        .set('serviceCardVO', payload || {})
        .updateIn(['serviceCardVO', 'cardItems'], cardItems =>
          (cardItems || [])
            .flatMap(cardItem => {
              if (cardItem.orderStatus === 1 || cardItem.orderStatus === 3 || cardItem.orderStatus === 300) {
                return cardItem.set('orderSort', 1);
              }
              return cardItem.set('orderSort', 2);
            })
            .filter(cardItem => {
              return (isFormalMeal(payload.diningForm) && cardItem.tableSyn) || payload.diningForm === 1;
            }),
        )
        .updateIn(['serviceCardVO', 'cardItems'], cardItems =>
          [].concat(cardItems).sort((a, b) => {
            return a.orderSort - b.orderSort;
          }),
        )
        .updateIn(['serviceCardVO', 'cardItems'], cardItems =>
          cardItems.flatMap(cardItem => {
            return cardItem.set('ownerId', payload.memberVO && payload.memberVO.customerId);
          }),
        );
    case 'SET_TOAST_PROPS':
      return state.set('toastProps', payload);
    case 'SET_SHOP_INFO':
      return state.set('shopInfo', payload);
    case 'SET_LOADING':
      return state.set('loading', payload);
    default:
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducer/shop-home/index.js